/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-08T17:39:58.08
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getContractSubjectEditInit,
	getContractSubjectView,
	getContractSubjectAggregateRootItemEditInit, //变更 新增
} from '@api/storagemanage/ARContractSubject';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getContractSubjectEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getContractSubjectEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getContractSubjectView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getContractSubjectView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		//变更 新增
		getContractSubjectAggregateRootItemEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getContractSubjectAggregateRootItemEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
